import { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';

// ============================================================
// useLogin – hook del formulario de inicio de sesión
// ============================================================

interface LoginForm {
  identifier: string;
  password: string;
}

interface UseLoginReturn {
  form: LoginForm;
  error: string | null;
  isSubmitting: boolean;
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleSubmit: (e: React.FormEvent) => Promise<void>;
}

export const useLogin = (onSuccess?: () => void): UseLoginReturn => {
  const { login } = useAuth();

  const [form, setForm]               = useState<LoginForm>({ identifier: '', password: '' });
  const [error, setError]             = useState<string | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setError(null);
    setForm(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!form.identifier.trim() || !form.password.trim()) {
      setError('Por favor complete todos los campos.');
      return;
    }

    setIsSubmitting(true);
    setError(null);

    try {
      await login(form);
      onSuccess?.();
    } catch (err: unknown) {
      // El backend retorna el mensaje exacto en body.message
      const msg = err instanceof Error ? err.message : 'Error de conexión. Intente nuevamente.';
      setError(msg);
    } finally {
      setIsSubmitting(false);
    }
  };

  return { form, error, isSubmitting, handleChange, handleSubmit };
};